// extracted by mini-css-extract-plugin
module.exports = {"custom-tooltip":"InvestmentsGraph_custom-tooltip__uvQG0","graph":"InvestmentsGraph_graph__bBpaQ"};